import { ECOMPANY_ROLE } from '@/domains/partners/multisport/enums/CompanyRole'

export const COMPANY_ROLES = [
  {
    text: 'form.companyRole.account',
    value: ECOMPANY_ROLE.ACCOUNT,
  },
  {
    text: 'form.companyRole.manager',
    value: ECOMPANY_ROLE.MANAGER,
  },
  {
    text: 'form.companyRole.operationManager',
    value: ECOMPANY_ROLE.OPERATION_MANAGER,
  },
  {
    text: 'form.companyRole.reception',
    value: ECOMPANY_ROLE.RECEPTION,
  },
  {
    text: 'form.companyRole.owner',
    value: ECOMPANY_ROLE.OWNER,
  },
  {
    text: 'form.companyRole.other',
    value: ECOMPANY_ROLE.OTHER,
  },
]
